import React, {useCallback, useEffect, useState} from 'react'
import { FileChip } from 'components/Shared/FileChip'
import { useErrorHandling } from 'context/errorHandling'
import ApiError from 'constants/ApiError'
import { HTTP_500_ERROR } from 'Constants'
import { Dropzone } from 'components/Shared/Dropzone'

export function FilesDropzone ({ initialFiles = [], onFilesUpdated, onUpload, onFileShow, disabled, label }) {
  const { handleError } = useErrorHandling()
  const [files, setFiles] = useState([])

  useEffect(() => {
    setFiles(initialFiles)
  }, [initialFiles, setFiles]);

  const onDrop = useCallback(acceptedFiles => {
    const filenames = files.map(value => value.filename)
    const newFiles = acceptedFiles.filter(
      file => !filenames.includes(file.filename))
    Promise.all(
      newFiles.map(file => onUpload(file)))
      .then(response => {
        const addedFiles = response
          .map(file => ({
            filename: file.filename,
              id: file.id
            })
          )

        const updatedFiles = [...files, ...addedFiles]
        setFiles(updatedFiles)
        onFilesUpdated(updatedFiles)
      }).catch(error => handleError(error, {
        [HTTP_500_ERROR]: ApiError.FileUploadFailure
      })
    )

  }, [files, handleError, onFilesUpdated, onUpload])

  function handleRemove (fileToRemove) {
    const updatedFiles = files.filter(file => fileToRemove.filename !== file.filename)
    setFiles(updatedFiles)
    onFilesUpdated(updatedFiles)
  }

  return (
    <div>
      <Dropzone files={files}
                onDrop={onDrop}
                disabled={disabled}
                label={label}
                chipRenderer={file =>
                  <FileChip
                    key={file.filename}
                    file={file}
                    maxTextLength={30}
                    onRemove={handleRemove}
                    onShow={onFileShow}/>}
      />
    </div>

  )
}
